import * as React from "react";
import { forwardRef } from "react";
const SvgIcChevronBold24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.11523 12.8828V11.1152L14.6152 3.61523L16.3828 5.38281L9.7666 11.999L16.3828 18.6152L14.6152 20.3828L7.11523 12.8828Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcChevronBold24);
export { ForwardRef as ReactComponent };
